const courseCreate = {
  en: {
    createHeader: {
      back: 'Courses',
      backAria: 'Back to courses',
      title: 'Create a course',
      subtitle: 'Give it a title, a cover and pricing — you can add lessons right after.',
    },
    details: {
      cardTitle: 'Course details',
      cardDesc: 'Name, short description, level and price.',
      titleLabel: 'Title',
      titlePlaceholder: 'e.g. Russian A1',
      titleHelp: 'At least 3 characters.',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'What will students learn? Keep it short and engaging.',
      descriptionHelp: 'Shown on the course card and overview page.',
      levelLabel: 'Level',
      priceLabel: 'Price',
      pricePlaceholder: '0',
      priceHelp: 'Leave 0 to make the course free.',
    },
    levels: {
      beginner: 'Beginner',
      intermediate: 'Intermediate',
      advanced: 'Advanced',
    },
    preview: {
      cardTitle: 'Card preview',
      hint: 'This is how the course will look in the list.',
      untitled: 'Untitled course',
    },
    cover: {
      cardTitle: 'Course cover',
      cardDesc: 'Design a cover here or upload your own image.',
    },
    actions: {
      cancel: 'Cancel',
      creating: 'Creating...',
      createCourse: 'Create course',
    },
    field: {
      title: 'Course title',
    },
    validation: {
      required: '{field} is required',
      minLength: '{field} must be at least {min} characters',
      maxLength: '{field} cannot exceed {max} characters',
    },
    errors: {
      loadCourseFailed: 'Failed to load course',
      publishFailed: 'Failed to publish course',
      addLessonFailed: 'Failed to add lesson',
      gradeFailed: 'Failed to submit grade',
      createMayHaveSucceeded: 'The course may already have been created: check the Courses list before trying again.',
      createRejected: 'The course could not be created. Check the title and price, then try again.',
    },
    prompts: {
      lessonTitle: 'Lesson title:',
      assignmentTitle: 'Assignment title:',
    },
    editHeader: {
      loadingTitle: 'Edit course',
      loadingText: 'Loading...',
      fallbackTitle: 'Courses schedule',
      featureCourse: 'Feature course',
      publishCourse: 'Publish course',
      edit: 'Edit',
      delete: 'Delete',
    },
    lessons: {
      addLesson: '+ Add lesson',
      count: '{n} lesson(s)',
      tasksButton: 'Tasks',
    },
    tasks: {
      heading: 'Tasks (assignments)',
      addTask: '+ Add task',
      loading: 'Loading...',
      viewAttempts: 'View attempts',
    },
    learningGrid: {
      learning1: 'Learning 1',
      learning2: 'Learning 2',
      learning3: 'Learning 3',
      learning4: 'Learning 4',
    },
    videoSection: {
      heading: 'Learning 4',
      uploadVideos: '+ Upload videos',
      saveContinue: 'Save & continue',
    },
    deleteModal: {
      title: 'Delete {target}',
      itemFallback: 'item',
      message: 'Are you sure you want to delete this learning? This action cannot be undone.',
    },
    attemptsModal: {
      title: 'Attempts',
      loading: 'Loading attempts...',
      colStudent: 'Student',
      colScore: 'Score',
      colPassed: 'Passed',
      colSubmitted: 'Submitted',
      passedYes: 'Yes',
      passedNo: 'No',
      grade: 'Grade',
    },
    gradeModal: {
      title: 'Grade attempt',
      score: 'Score',
      feedback: 'Feedback',
      passed: 'Passed',
      cancel: 'Cancel',
      saveGrade: 'Save grade',
    },
  },
  ru: {
    createHeader: {
      back: 'Курсы',
      backAria: 'Назад к курсам',
      title: 'Создать курс',
      subtitle: 'Добавьте название, обложку и цену — уроки можно будет добавить сразу после.',
    },
    details: {
      cardTitle: 'Детали курса',
      cardDesc: 'Название, краткое описание, уровень и цена.',
      titleLabel: 'Название',
      titlePlaceholder: 'напр. Русский язык A1',
      titleHelp: 'Не менее 3 символов.',
      descriptionLabel: 'Описание',
      descriptionPlaceholder: 'Чему научатся студенты? Кратко и увлекательно.',
      descriptionHelp: 'Отображается на карточке курса и странице обзора.',
      levelLabel: 'Уровень',
      priceLabel: 'Цена',
      pricePlaceholder: '0',
      priceHelp: 'Оставьте 0, чтобы сделать курс бесплатным.',
    },
    levels: {
      beginner: 'Начинающий',
      intermediate: 'Средний',
      advanced: 'Продвинутый',
    },
    preview: {
      cardTitle: 'Предпросмотр карточки',
      hint: 'Так курс будет выглядеть в списке.',
      untitled: 'Курс без названия',
    },
    cover: {
      cardTitle: 'Обложка курса',
      cardDesc: 'Создайте обложку здесь или загрузите своё изображение.',
    },
    actions: {
      cancel: 'Отмена',
      creating: 'Создание...',
      createCourse: 'Создать курс',
    },
    field: {
      title: 'Название курса',
    },
    validation: {
      required: '{field} обязательно для заполнения',
      minLength: '{field} должно содержать не менее {min} символов',
      maxLength: '{field} не должно превышать {max} символов',
    },
    errors: {
      loadCourseFailed: 'Не удалось загрузить курс',
      publishFailed: 'Не удалось опубликовать курс',
      addLessonFailed: 'Не удалось добавить урок',
      gradeFailed: 'Не удалось сохранить оценку',
      createMayHaveSucceeded: 'Курс мог быть уже создан: проверьте список курсов, прежде чем повторять.',
      createRejected: 'Не удалось создать курс. Проверьте название и цену и попробуйте ещё раз.',
    },
    prompts: {
      lessonTitle: 'Название урока:',
      assignmentTitle: 'Название задания:',
    },
    editHeader: {
      loadingTitle: 'Редактирование курса',
      loadingText: 'Загрузка...',
      fallbackTitle: 'Расписание курсов',
      featureCourse: 'Рекомендовать курс',
      publishCourse: 'Опубликовать курс',
      edit: 'Изменить',
      delete: 'Удалить',
    },
    lessons: {
      addLesson: '+ Добавить урок',
      count: '{n} урок(ов)',
      tasksButton: 'Задания',
    },
    tasks: {
      heading: 'Задания',
      addTask: '+ Добавить задание',
      loading: 'Загрузка...',
      viewAttempts: 'Посмотреть попытки',
    },
    learningGrid: {
      learning1: 'Обучение 1',
      learning2: 'Обучение 2',
      learning3: 'Обучение 3',
      learning4: 'Обучение 4',
    },
    videoSection: {
      heading: 'Обучение 4',
      uploadVideos: '+ Загрузить видео',
      saveContinue: 'Сохранить и продолжить',
    },
    deleteModal: {
      title: 'Удалить {target}',
      itemFallback: 'элемент',
      message: 'Вы уверены, что хотите удалить этот раздел обучения? Это действие нельзя отменить.',
    },
    attemptsModal: {
      title: 'Попытки',
      loading: 'Загрузка попыток...',
      colStudent: 'Студент',
      colScore: 'Балл',
      colPassed: 'Пройдено',
      colSubmitted: 'Отправлено',
      passedYes: 'Да',
      passedNo: 'Нет',
      grade: 'Оценить',
    },
    gradeModal: {
      title: 'Оценить попытку',
      score: 'Балл',
      feedback: 'Комментарий',
      passed: 'Пройдено',
      cancel: 'Отмена',
      saveGrade: 'Сохранить оценку',
    },
  },
  uz: {
    createHeader: {
      back: 'Kurslar',
      backAria: 'Kurslarga qaytish',
      title: 'Kurs yaratish',
      subtitle: "Nom, muqova va narxni kiriting — darslarni keyinroq qo'shishingiz mumkin.",
    },
    details: {
      cardTitle: 'Kurs tafsilotlari',
      cardDesc: 'Nom, qisqa tavsif, daraja va narx.',
      titleLabel: 'Nomi',
      titlePlaceholder: 'masalan, Rus tili A1',
      titleHelp: 'Kamida 3 ta belgi.',
      descriptionLabel: 'Tavsif',
      descriptionPlaceholder: "O'quvchilar nimani o'rganadi? Qisqa va qiziqarli yozing.",
      descriptionHelp: "Kurs kartochkasi va umumiy ko'rinish sahifasida ko'rsatiladi.",
      levelLabel: 'Daraja',
      priceLabel: 'Narxi',
      pricePlaceholder: '0',
      priceHelp: "Kursni bepul qilish uchun 0 qoldiring.",
    },
    levels: {
      beginner: "Boshlang'ich",
      intermediate: "O'rta",
      advanced: 'Yuqori',
    },
    preview: {
      cardTitle: "Kartochka ko'rinishi",
      hint: "Kurs ro'yxatda shunday ko'rinadi.",
      untitled: 'Nomsiz kurs',
    },
    cover: {
      cardTitle: 'Kurs muqovasi',
      cardDesc: "Muqovani shu yerda yarating yoki o'z rasmingizni yuklang.",
    },
    actions: {
      cancel: 'Bekor qilish',
      creating: 'Yaratilmoqda...',
      createCourse: 'Kurs yaratish',
    },
    field: {
      title: 'Kurs nomi',
    },
    validation: {
      required: "{field} to'ldirilishi shart",
      minLength: "{field} kamida {min} ta belgidan iborat bo'lishi kerak",
      maxLength: "{field} {max} ta belgidan oshmasligi kerak",
    },
    errors: {
      loadCourseFailed: "Kursni yuklab bo'lmadi",
      publishFailed: "Kursni e'lon qilib bo'lmadi",
      addLessonFailed: "Darsni qo'shib bo'lmadi",
      gradeFailed: "Bahoni saqlab bo'lmadi",
      createMayHaveSucceeded: "Kurs allaqachon yaratilgan bo'lishi mumkin: qayta urinishdan oldin kurslar ro'yxatini tekshiring.",
      createRejected: "Kursni yaratib bo'lmadi. Nom va narxni tekshirib, qaytadan urinib ko'ring.",
    },
    prompts: {
      lessonTitle: 'Dars nomi:',
      assignmentTitle: 'Topshiriq nomi:',
    },
    editHeader: {
      loadingTitle: 'Kursni tahrirlash',
      loadingText: 'Yuklanmoqda...',
      fallbackTitle: 'Kurslar jadvali',
      featureCourse: 'Kursni tavsiya qilish',
      publishCourse: "Kursni e'lon qilish",
      edit: 'Tahrirlash',
      delete: "O'chirish",
    },
    lessons: {
      addLesson: "+ Dars qo'shish",
      count: '{n} ta dars',
      tasksButton: 'Topshiriqlar',
    },
    tasks: {
      heading: 'Topshiriqlar',
      addTask: "+ Topshiriq qo'shish",
      loading: 'Yuklanmoqda...',
      viewAttempts: "Urinishlarni ko'rish",
    },
    learningGrid: {
      learning1: "O'rganish 1",
      learning2: "O'rganish 2",
      learning3: "O'rganish 3",
      learning4: "O'rganish 4",
    },
    videoSection: {
      heading: "O'rganish 4",
      uploadVideos: '+ Video yuklash',
      saveContinue: 'Saqlash va davom etish',
    },
    deleteModal: {
      title: "{target} o'chirish",
      itemFallback: 'element',
      message: "Ushbu o'rganish bo'limini o'chirmoqchimisiz? Bu amalni bekor qilib bo'lmaydi.",
    },
    attemptsModal: {
      title: 'Urinishlar',
      loading: 'Urinishlar yuklanmoqda...',
      colStudent: "O'quvchi",
      colScore: 'Ball',
      colPassed: "O'tdimi",
      colSubmitted: 'Topshirilgan',
      passedYes: 'Ha',
      passedNo: "Yo'q",
      grade: 'Baholash',
    },
    gradeModal: {
      title: 'Urinishni baholash',
      score: 'Ball',
      feedback: 'Izoh',
      passed: "O'tdi",
      cancel: 'Bekor qilish',
      saveGrade: 'Bahoni saqlash',
    },
  },
};

export default courseCreate;
